module.exports = __webpack_public_path__ + "img/ic-add-fund-yellow.040f3b97.svg";